var __TEMP__ = require('./toString.js');var toString = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./upperFirst.js');var upperFirst = __REQUIRE_DEFAULT__(__TEMP__);

/**
 * Converts the first character of `string` to upper case and the remaining
 * to lower case.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to capitalize.
 * @returns {string} Returns the capitalized string.
 * @example
 *
 * _.capitalize('FRED');
 * // => 'Fred'
 */
function capitalize(string) {
  return upperFirst(toString(string).toLowerCase());
}

if (!exports.__esModule) Object.defineProperty(exports, "__esModule", { value: true });exports.default = capitalize;
